// controls the Performance and Process reports visibility in Reports -> sub-navigation
export const hasAccessToSpecialReports = (args: {
  canManageData: boolean;
  canAccessReportsAndDataSourceFilters: boolean;
  canAccessInsightboards: boolean;
  dataSourcesAvailable: boolean;
}): boolean => {
  return (args.canManageData || args.canAccessReportsAndDataSourceFilters) && args.canAccessInsightboards && args.dataSourcesAvailable;
};
